import { useState } from 'react';
import type { FormEvent, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { ApiError } from '../../api/client.js';

export function MfaVerifyPage(): ReactNode {
  const { verifyMfa } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await verifyMfa(code);
      nav('/vendor/dashboard');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'MFA verify failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main aria-label="mfa-verify">
      <h1>Verify MFA</h1>
      <form onSubmit={onSubmit} aria-label="mfa-form">
        <label>Code
          <input value={code} onChange={(e) => setCode(e.target.value)} aria-label="mfa-code" required />
        </label>
        {error ? <div role="alert">{error}</div> : null}
        <button type="submit" disabled={busy}>{busy ? 'Verifying…' : 'Verify'}</button>
      </form>
    </main>
  );
}
